import * as FSR from "src/generated/hooks/form-service/requests";
import * as GQL from "src/types/graphql";

export type ParentFormSchoolRank =
  GQL.GetParentFormsIndex_person_forms_form_school_ranks;

export type FormSchoolRankWithAdmissions = ParentFormSchoolRank & {
  sub_status: string | null;
  offers: ReadonlyArray<{
    readonly id: string;
    readonly status: GQL.offer_status_enum;
    readonly expires_at: string | null;
  }>;
  waitlists: ReadonlyArray<{
    readonly id: string;
    readonly status: GQL.waitlist_status_enum;
    readonly waitlist_position: { readonly position: number } | null;
  }>;
};

const EMPTY_ADMISSIONS: Pick<
  FormSchoolRankWithAdmissions,
  "sub_status" | "offers" | "waitlists"
> = {
  sub_status: null,
  offers: [],
  waitlists: [],
};

export function mergeAdmissionsIntoFormSchoolRanks(
  gqlRanks: readonly ParentFormSchoolRank[],
  admissions: FSR.GetAdmissionsForMeResponse | null | undefined
): FormSchoolRankWithAdmissions[] {
  const admissionsByRankId = new Map(
    admissions?.map((rank) => [rank.form_school_rank_id, rank]) ?? []
  );

  return gqlRanks.map((rank) => {
    const admissionRank = admissionsByRankId.get(rank.id);
    if (!admissionRank) {
      return {
        ...rank,
        ...EMPTY_ADMISSIONS,
      };
    }

    return {
      ...rank,
      sub_status: admissionRank.sub_status,
      offers: admissionRank.offers.map((offer) => ({
        id: offer.id,
        status: offer.status as GQL.offer_status_enum,
        expires_at: offer.expires_at,
      })),
      waitlists: admissionRank.waitlists.map((waitlist) => ({
        id: waitlist.id,
        status: waitlist.status as GQL.waitlist_status_enum,
        waitlist_position: waitlist.waitlist_position,
      })),
    };
  });
}

export function rankHasMayHavePendingAutoDecisions(
  admissions: FSR.GetAdmissionsForMeResponse
): boolean {
  return admissions.some((rank) => rank.may_have_pending_auto_decisions);
}
